import { useModal } from '@stores';

const Modal = () => {
  const { modal } = useModal();
  const ModalContent = modal?.content;
  const modalProps = modal?.props;
  return !!ModalContent ? <ModalContent {...modalProps} /> : null;
};

export default Modal;
